import { render } from "./copy.vue?vue&type=template&id=6a8ef62c&ts=true"
import script from "./copy.vue?vue&type=script&lang=ts"
export * from "./copy.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__